import type { CityConfig } from "../city-template/types";

export const tacomaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — WA Dept of Health Vital Records", href: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", description: "Official Washington vital records office in Tumwater" },
    { label: "Marriage Licenses — Pierce County Auditor", href: "https://www.piercecountywa.gov/", description: "Pierce County Auditor — marriage license issuance" },
    { label: "Divorce Records — Pierce County Clerk", href: "https://www.piercecountywa.gov/", description: "Pierce County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of WA DOH for online vital record orders" },
  ],
  city: "Tacoma",
  state: "Washington",
  stateAbbr: "WA",
  slug: "tacoma",
  route: "/cities/tacoma",
  title: "Emergency Passport Tacoma WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Tacoma, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Tacoma, Lakewood, Puyallup, and all Pierce County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Tacoma, WA",
  heroSubtitle: "Tacoma travelers — from Port of Tacoma workers to Pacific Lutheran University students to South Sound families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Pierce County and the South Sound region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Tacoma%20Washington%20downtown%20with%20Mount%20Rainier%20in%20the%20background%2C%20the%20Tacoma%20Narrows%20Bridge%2C%20Commencement%20Bay%20waterfront%2C%20historic%20architecture%20mixed%20with%20modern%20buildings%2C%20lush%20evergreen%20forests%20and%20waterfront%2C%20warm%20golden%20afternoon%20sunlight%2C%20Pacific%20Northwest%20South%20Sound%20city%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=tacoma-hero-001&orientation=landscape",
  heroImageAlt: "Tacoma Washington downtown with Mount Rainier backdrop and Commencement Bay waterfront",
  geoPosition: "47.2529;-122.4443",
  geoPlacename: "Tacoma, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 35 miles north of Tacoma via I-5",
  },
  nearbyCitiesZips: [
    { name: "Tacoma", zips: "98401, 98402, 98403, 98404, 98405, 98406, 98407, 98408, 98409, 98411, 98413, 98416, 98418, 98421, 98422, 98424, 98444, 98445, 98446, 98447, 98448, 98464, 98465, 98466, 98467, 98493" },
    { name: "Lakewood", zips: "98439, 98496, 98497, 98498, 98499" },
    { name: "Puyallup", zips: "98371, 98372, 98373, 98374, 98375" },
    { name: "Gig Harbor", zips: "98329, 98332, 98335" },
    { name: "University Place", zips: "98466, 98467" },
    { name: "Fircrest", zips: "98466" },
    { name: "Fife", zips: "98424" },
    { name: "Edgewood", zips: "98371, 98372" },
    { name: "Milton", zips: "98354" },
    { name: "Sumner", zips: "98352, 98390" },
    { name: "Bonney Lake", zips: "98391" },
    { name: "Orting", zips: "98360" },
    { name: "Eatonville", zips: "98328" },
    { name: "Roy", zips: "98580" },
    { name: "Spanaway", zips: "98387" },
    { name: "Parkland", zips: "98444, 98445, 98446, 98447, 98448" },
    { name: "Tacoma Narrows", zips: "98407" },
    { name: "Steilacoom", zips: "98388" },
    { name: "DuPont", zips: "98327" },
    { name: "Joint Base Lewis-McChord", zips: "98433, 98438, 98439" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 35 minutes up I-5" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-anchor-line", title: "Port & Military Travel Hub", desc: "Serving Port of Tacoma, JBLM, and South Sound professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Pierce County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Emergency passport help in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Urgent passport services in Spokane, WA", route: "/cities/spokane" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Tacoma, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — just 35 minutes north via I-5. Tacoma residents can ship from any UPS or FedEx in Pierce County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Tacoma, Lakewood, Puyallup, Gig Harbor, University Place, Fircrest, Fife, Edgewood, Milton, Sumner, Bonney Lake, Spanaway, Parkland, Steilacoom, DuPont, and all of Pierce County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Tacoma and the South Sound region. From downtown Tacoma near the Museum of Glass and the waterfront to the military community at Joint Base Lewis-McChord, from the Puyallup Valley to the Gig Harbor peninsula — we serve all of Pierce County and beyond.",
  nearbyCitiesIntro: "We serve Tacoma and all nearby communities including Lakewood, Puyallup, Gig Harbor, University Place, Fircrest, Fife, Edgewood, Milton, Sumner, Bonney Lake, Orting, Eatonville, Spanaway, Parkland, Steilacoom, DuPont, and the Joint Base Lewis-McChord community. We also serve Thurston County and southern King County.",
  howItWorksIntro: "Most Tacoma travelers complete everything online and ship documents overnight. No need to drive 35 minutes up I-5 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Tacoma is a major South Sound hub with significant travel demand from the Port of Tacoma, Joint Base Lewis-McChord, and Pacific Lutheran University. Here are the most common passport mistakes we see from Pierce County travelers.",
  testimonialsIntro: "Tacoma travelers — from port workers to military families to South Sound professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Tacoma, WA? Here are the most common ones we hear from South Sound travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — local proximity", "No I-5 traffic or downtown parking hassle", "Perfect for military and port travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — local proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35 minutes to Seattle downtown", "Parking and traffic in downtown Seattle"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Tacoma travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for last-minute deployments, Alaska cruises, and Pacific Rim business travel.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — local proximity", "Pierce County military and port travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Tacoma adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your South Sound address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Tacoma residents and families — including PLU students, new citizens, and South Sound families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Tacoma residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Tacoma and South Sound families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Tacoma and South Sound residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Tacoma WA", description: "Urgent passport processing for Tacoma Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Tacoma WA", description: "Fast passport renewal for Tacoma Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Tacoma WA", description: "New passport application services for Tacoma Washington residents applying for their first passport." },
    { name: "Child Passport Tacoma WA", description: "Minor passport services for Tacoma Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sgt. James R.",
      location: "Joint Base Lewis-McChord, WA",
      rating: 5,
      text: "Deployment notice with 5 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store in Lakewood and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Puyallup, WA",
      rating: 5,
      text: "Family vacation to Mexico with 8 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Meridian and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Robert H.",
      location: "Tacoma, WA",
      rating: 5,
      text: "Business trip to Seoul with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for the South Sound.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa K.",
      location: "Gig Harbor, WA",
      rating: 5,
      text: "Lost my passport the week before a cruise to Alaska. Fast Passport Center replaced it in 48 hours. The local proximity to Seattle made all the difference.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "tac-1",
      name: "Tacoma Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4001 S Pine St",
      city: "Tacoma",
      state: "WA",
      zip: "98409",
      phone: "(253) 472-0110",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Tacoma, near Tacoma Mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Tacoma acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown and south Tacoma residents.",
      icon: "ri-mail-line",
    },
    {
      id: "tac-2",
      name: "Lakewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10509 Gravelly Lake Dr SW",
      city: "Lakewood",
      state: "WA",
      zip: "98499",
      phone: "(253) 588-7994",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lakewood, approximately 5 miles south of downtown Tacoma",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Lakewood, JBLM, and west Pierce County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "tac-3",
      name: "Puyallup Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 N Meridian",
      city: "Puyallup",
      state: "WA",
      zip: "98371",
      phone: "(253) 841-0234",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Puyallup, approximately 8 miles east of downtown Tacoma",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Puyallup, Sumner, and east Pierce County. Good alternative for east-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "tac-4",
      name: "Gig Harbor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3112 Judson St",
      city: "Gig Harbor",
      state: "WA",
      zip: "98335",
      phone: "(253) 851-2744",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Gig Harbor, approximately 15 miles west of downtown Tacoma",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Gig Harbor, Fox Island, and the Key Peninsula. Serves the western peninsula communities.",
      icon: "ri-mail-line",
    },
    {
      id: "tac-5",
      name: "Pierce County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "930 Tacoma Ave S",
      city: "Tacoma",
      state: "WA",
      zip: "98402",
      phone: "(253) 798-7487",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Tacoma County Courthouse",
      website: "https://www.piercecountywa.gov/",
      websiteLabel: "Pierce County",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-5 traffic to downtown Seattle", fpc: "No — ship from Tacoma" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Military & Port Travel", agency: "No special guidance", fpc: "Yes — deployment and cruise expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Tacoma port workers and military families often discover passport issues just before deployment or cruise departure. Alaska cruise season (May–September) peaks from Seattle. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Pacific Avenue or in the Lakewood area sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Pierce County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Tacoma Post Office appointments fill during summer cruise season and military deployment periods. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating I-5 Traffic to Seattle",
      description: "Many Tacoma residents attempt to drive to the Seattle passport agency in an emergency. I-5 traffic can turn a 35-minute trip into 2 hours — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Alaska cruise season from Seattle peaks May–September — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Tacoma area or South Sound region." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Tacoma, Lakewood, or Puyallup." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — leveraging the close South Sound proximity." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Tacoma address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Tacoma, WA?", a: "Fast Passport Center offers emergency passport processing in Tacoma, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — just 35 minutes north via I-5." },
    { q: "Does Tacoma have its own passport agency?", a: "No — Tacoma does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 35 minutes north via I-5). Fast Passport Center's courier service means Tacoma residents never need to deal with I-5 traffic." },
    { q: "Can I get an expedited passport in Lakewood, Puyallup, or Gig Harbor?", a: "Absolutely. Fast Passport Center serves all of the South Sound region including Lakewood, Puyallup, Gig Harbor, University Place, Spanaway, and the Joint Base Lewis-McChord community. Our service works the same way everywhere." },
    { q: "What airport do Tacoma travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport for Tacoma and the South Sound. SEA is 25 miles north via I-5 and offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines are major hubs. Always verify passport validity for at least 6 months past your return date." },
    { q: "Can I use the Seattle passport agency for Alaska cruise travel?", a: "Yes. The Seattle Passport Agency processes emergency passports for Alaska cruise travelers with confirmed departures within 14 days. Seattle is the #1 Alaska cruise departure port in the United States. Tacoma is ideally positioned for cruise departures — just 35 minutes from Seattle." },
    { q: "How much does an expedited passport cost in Tacoma, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Tacoma?", a: "Walgreens, CVS, and Rite Aid stores throughout Tacoma and Lakewood offer passport photos. UPS Store and FedEx Office locations also provide them. Many locations on Pacific Avenue and in the Puyallup area offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Joint Base Lewis-McChord?", a: "Yes. Fast Passport Center serves all of the South Sound including the Joint Base Lewis-McChord community. We understand military deployment schedules and can accommodate urgent PCS and TDY travel needs. Our courier service is especially valuable for service members who need to stay on base." },
  ],
  photoLocations: [
    { name: "Walgreens — Pacific Avenue", address: "1901 S Union Ave, Tacoma, WA 98405", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Rite Aid — Lakewood", address: "10505 Gravelly Lake Dr SW, Lakewood, WA 98499", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Puyallup", address: "310 E Main Ave, Puyallup, WA 98372", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Tacoma Mall", address: "4502 S Steele St, Tacoma, WA 98409", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Tacoma", address: "4001 S Pine St, Tacoma, WA 98409", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Puyallup", address: "312 W Main Ave, Puyallup, WA 98371", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Puyallup and east Pierce County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "25 miles north of Tacoma via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Tacoma and the South Sound. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Alaska cruise passengers fly through SEA regularly.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "TIW",
      name: "Tacoma Narrows Airport",
      distance: "Approximately 5 miles southwest of downtown Tacoma",
      address: "1202 26th Ave NW, Gig Harbor, WA 98335",
      note: "General aviation airport serving the South Sound. No commercial passenger service. Used for private and corporate aviation.",
      flightUrl: "https://www.piercecountywa.gov/",
      flightLabel: "TIW Info",
      featured: false,
    },
    {
      code: "PAE",
      name: "Paine Field (Snohomish County)",
      distance: "Approximately 50 miles north of Tacoma via I-5",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Commercial flights to select domestic destinations. Alaska Airlines and United serve Paine Field. Alternative to SEA for some domestic travel.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: false,
    },
  ],
};